import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    Delete as DeleteIcon,
    ListAlt as ListAltIcon,
    EmojiObjects as EmojiObjectsIcon,
    Warning as WarningIcon,
    CheckCircle as CheckCircleIcon,
    ArrowForwardIos as ArrowForwardIosIcon
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    導入
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('local-rules')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    地域ごとのゴミ出しルール
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('duty-roster')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ゴミ当番表の作り方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('separation-tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    分別をラクにするアイデア
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble-cases')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアでのトラブル事例と対策
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    導入
                </Typography>
                <Typography variant="body1" gutterBottom>
                    ルームシェアは、多様な人たちと一緒に暮らしながら、家賃や光熱費を節約できる魅力的な住まい方です。しかし、共同生活を送るうえで、「ゴミ出し」は意外なほどトラブルの火種になりがち。ゴミが溜まってしまったり、分別ルールを守らず周囲と摩擦が生まれたり…。<br />
                    本記事では、<b>地域ごとのゴミ出しルール</b>や、<b>効率的な当番表の作り方</b>、<b>分別をラクにする工夫</b>、さらに実際に起きたトラブル事例とその対策まで、徹底解説します。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <img
                        src="/images/blog/share-living-garbage-sort_roomshare-gomidashi-rule-tips.jpg"
                        alt="明るい共有リビングでルームメイトたちが色分けされたゴミ箱の前で分別について話し合っている様子。リビングはウッド調の家具で統一され、笑顔があふれている。"
                        style={{ width: '100%', maxWidth: 500, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                    />
                </Box>
            </Box>

            {/* 地域ごとのゴミ出しルール */}
            <Box id="local-rules" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <DeleteIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    地域ごとのゴミ出しルール
                </Typography>
                <Typography variant="body1" gutterBottom>
                    ゴミ出しのルールは自治体によって驚くほど異なります。ルームメイトが引っ越してきたばかりの場合、前の地域の「常識」のまま過ごしてしまうケースも。<b>まずは現在住んでいる自治体のルールを全員でしっかり確認</b>しましょう。
                </Typography>
                <Box sx={{ my: 2 }}>
                    <Paper elevation={1} sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#fafafa', borderRadius: 2 }}>
                        <Typography variant="h6" sx={{ color: 'primary.main', mb: 1 }}>
                            よくある分別区分
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <List>
                                    <ListItem>
                                        <ListItemIcon><Chip label="燃えるゴミ" color="primary" variant="outlined" /></ListItemIcon>
                                        <ListItemText primary="生ゴミ・紙くず・布類など" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><Chip label="燃えないゴミ" color="secondary" variant="outlined" /></ListItemIcon>
                                        <ListItemText primary="金属類・ガラス・陶器など" />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <List>
                                    <ListItem>
                                        <ListItemIcon><Chip label="資源ゴミ" color="success" variant="outlined" /></ListItemIcon>
                                        <ListItemText primary="ペットボトル・缶・ビン・古紙など" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><Chip label="粗大ゴミ" color="warning" variant="outlined" /></ListItemIcon>
                                        <ListItemText primary="家具・家電など大型のもの" />
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    ゴミ出しの曜日や出せる時間、ゴミ袋の指定なども自治体ごとに異なります。ルームメイトと一緒に、
                    <b>「自治体の公式サイト」や「配布されるパンフレット」</b>を確認し、<b>冷蔵庫や玄関にルール一覧を掲示</b>しましょう。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" sx={{ color: 'primary.dark', fontWeight: 'bold' }}>
                    【ポイント】<br />
                    ルールを知らないまま出してしまうと、近隣トラブルや回収拒否のリスクも。<br />
                    <ArrowForwardIosIcon fontSize="small" sx={{ verticalAlign: 'middle', color: 'primary.main' }} /> まずは正しい情報共有が大切！
                </Typography>
            </Box>

            {/* ゴミ当番表の作り方 */}
            <Box id="duty-roster" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <ListAltIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    ゴミ当番表の作り方
                </Typography>
                <Typography variant="body1" gutterBottom>
                    ゴミ出しは、<b>誰かに偏ったり、忘れられてしまうとストレスの原因</b>に。そこで役立つのが「ゴミ当番表」です。簡単な工夫で「うっかり忘れ」や「不公平感」を防げます。
                </Typography>
                <Paper elevation={0} sx={{ p: 2, my: 2, bgcolor: '#f1f8e9', borderRadius: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        当番表作成のステップ
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon sx={{ color: 'success.main' }} /></ListItemIcon>
                            <ListItemText
                                primary="① ゴミの種類ごとに回収曜日を把握"
                                secondary="例：燃えるゴミは火・金、資源ゴミは水など"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon sx={{ color: 'success.main' }} /></ListItemIcon>
                            <ListItemText
                                primary="② メンバー全員のスケジュールを確認"
                                secondary="在宅時間・出勤日などを考慮"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon sx={{ color: 'success.main' }} /></ListItemIcon>
                            <ListItemText
                                primary="③ 1ヶ月単位でローテーション表を作成"
                                secondary="曜日ごと、または週ごとに当番を割り振る"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleIcon sx={{ color: 'success.main' }} /></ListItemIcon>
                            <ListItemText
                                primary="④ 見やすい場所に掲示＆全員で確認"
                                secondary="冷蔵庫や玄関ドア、共有カレンダーアプリもおすすめ"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <img
                            src="/images/blog/garbage-duty-roster_roomshare-gomidashi-rule-tips.jpg"
                            alt="カラフルなマグネットで作成されたゴミ当番表が冷蔵庫に貼られ、ルームメイトが指さして次の担当を確認している場面。明るいキッチンが背景にある。"
                            style={{ width: '100%', borderRadius: 10, boxShadow: '0 1px 6px rgba(0,0,0,0.08)' }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} alignSelf="center">
                        <Typography variant="body2">
                            <b>POINT:</b> <br />
                            <EmojiObjectsIcon sx={{ verticalAlign: 'middle', color: 'warning.main' }} />
                            「紙の表」＋「共有のGoogleカレンダーやLINEグループでリマインド」を組み合わせると、うっかり忘れが減ります！
                        </Typography>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" sx={{ color: 'primary.dark', fontWeight: 'bold' }}>
                    【アドバイス】<br />
                    予定が変わった場合は、交代や代行のルールを事前に決めておくとトラブル回避に繋がります。
                </Typography>
            </Box>

            {/* 分別をラクにするアイデア */}
            <Box id="separation-tips" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <EmojiObjectsIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    分別をラクにするアイデア
                </Typography>
                <Typography variant="body1" gutterBottom>
                    ゴミの分別が面倒だと、つい適当に捨ててしまいがち。<b>分別が「自然とできる」仕組みを作る</b>ことで、全員がストレスなくルールを守れるようになります。
                </Typography>
                <Paper elevation={0} sx={{ p: 2, my: 2, bgcolor: '#ffe0b2', borderRadius: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        分別ラクラク！具体的な工夫
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <Chip label="色分けゴミ箱" color="primary" variant="outlined" />
                            </ListItemIcon>
                            <ListItemText primary="種類ごとにカラーやラベルを付けて一目で分かるようにする" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Chip label="分別ポスター" color="secondary" variant="outlined" />
                            </ListItemIcon>
                            <ListItemText primary="自治体の分別表やオリジナルのイラスト表を掲示" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Chip label="ゴミ袋ストック" color="success" variant="outlined" />
                            </ListItemIcon>
                            <ListItemText primary="指定袋を常にストック、ゴミ箱の近くに設置" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Chip label="分別アプリ" color="info" variant="outlined" />
                            </ListItemIcon>
                            <ListItemText primary="わからないときは自治体公式アプリや「ごみ分別ナビ」などを活用" />
                        </ListItem>
                    </List>
                </Paper>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            <b>分別表示を工夫すると、慣れていないルームシェア相手でもすぐ理解できます！</b>
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="success" />
                                </ListItemIcon>
                                <ListItemText primary="ゴミ箱のフタや正面にラベルシールを貼る" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="success" />
                                </ListItemIcon>
                                <ListItemText primary="迷ったときは確認する雰囲気を作る" />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src="/images/blog/garbage-separation-idea_roomshare-gomidashi-rule-tips.jpg"
                            alt="キッチンの隅に設置された4色の分別ゴミ箱セット。各ゴミ箱に大きなラベルとイラストが貼られ、誰でも簡単に分別できるよう工夫されている。"
                            style={{ width: '100%', borderRadius: 10, boxShadow: '0 1px 6px rgba(0,0,0,0.08)' }}
                        />
                    </Grid>
                </Grid>
                <Typography variant="body2" sx={{ color: 'primary.dark', fontWeight: 'bold' }}>
                    【コツ】<br />
                    分別のルールやゴミ出しの流れが「見える化」されていれば、トラブルも激減します。
                </Typography>
            </Box>

            {/* ルームシェアでのトラブル事例と対策 */}
            <Box id="trouble-cases" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <WarningIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'warning.main' }} />
                    ルームシェアでのトラブル事例と対策
                </Typography>
                <Typography variant="body1" gutterBottom>
                    ゴミ出しや分別のルールを巡っては、どんなに仲の良いメンバー同士でも時にトラブルが起こります。<br />
                    ここでは<strong>実際に多いトラブル例</strong>と、その解決策を紹介します。
                </Typography>
                <Grid container spacing={2} sx={{ my: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ bgcolor: '#fffde7', borderLeft: '5px solid #fbc02d', boxShadow: 1 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    ケース1：ゴミ放置＆当番忘れ
                                </Typography>
                                <Typography variant="body2">
                                    <b>現象：</b>ゴミ出し当番が当日寝坊や外出で出し忘れ、ゴミが溜まってしまう。<br />
                                    <b>対策：</b>リマインダー機能付きのカレンダーやメッセージアプリを活用。<br />
                                    交代や代行のルールを明文化しておくと安心。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ bgcolor: '#f3e5f5', borderLeft: '5px solid #7e57c2', boxShadow: 1 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    ケース2：分別ミスで回収拒否
                                </Typography>
                                <Typography variant="body2">
                                    <b>現象：</b>ペットボトルや缶のラベルを剥がさずに出してしまい、回収されなかった。<br />
                                    <b>対策：</b>ゴミ箱の近くに「分別チェックリスト」を貼り、迷った時は必ず相談。<br />
                                    定期的に全員でルール再確認の時間を設けるのも◎。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ my: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ bgcolor: '#e3f2fd', borderLeft: '5px solid #1976d2', boxShadow: 1 }}>
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    ケース3：担当外の人が出すことに不満
                                </Typography>
                                <Typography variant="body2">
                                    <b>現象：</b>当番が忘れたりサボったりした結果、他の人が仕方なくゴミ出し。後から「自分ばかり」と不満が…<br />
                                    <b>対策：</b>当番表で担当を明確にし、感謝や声かけを忘れない。<br />
                                    「できないときは必ず事前連絡」のルール徹底がカギ。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>

                    </Grid>
                </Grid>
                <Paper elevation={0} sx={{ p: 2, my: 2, bgcolor: '#ffe0b2', borderRadius: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>
                        トラブルを防ぐ3つのポイント
                    </Typography>
                    <List sx={{ pl: 2 }}>
                        <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="小さな疑問や不満も、定期的に全員で話し合う" />
                        </ListItem>
                        <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="ルールや当番表は“見える化”し、誰でも確認できるように" />
                        </ListItem>
                        <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
                            <ListItemText primary="ありがとう・ごめんねの声かけを大切に" />
                        </ListItem>
                    </List>
                </Paper>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ
                </Typography>
                <Typography variant="body1" gutterBottom>
                    ルームシェア生活では、ゴミ出しや分別のルールを「みんなで共有し、仕組み化」することが快適な毎日のカギ。<br />
                    <b>自治体ごとのルール確認</b>、<b>当番表や分別の工夫</b>、<b>コミュニケーション重視</b>で、ストレスフリーな共同生活を実現しましょう！
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>

                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-gomidashi-rule-tips',
    slug: 'roomshare-gomidashi-rule-tips',
    title: 'ルームシェアでのゴミ出しルールと分別のコツ',
    excerpt: '地域ごとのルール\nゴミ当番表の作り方\n分別をラクにするアイデア\nトラブル事例',
    coverImage: '/images/blog/cover-roomshare-gomidashi_roomshare-gomidashi-rule-tips.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。木目調の家具と観葉植物が心地よい空間を演出している。',
    publishedAt: '2024-06-19T09:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '生活のコツ', 'トラブル対策'],
    tags: ['ゴミ出し', '分別', '当番表', '共同生活', 'ルームシェア'],
    author: {
        name: '松本 洋介',
        avatar: '/images/avatars/yosuke-matsumoto.jpg',
        bio: 'シェアハウス運営歴10年以上。多くのルームシェア物件で生活ルールや快適な共同生活の仕組み作りをサポートしてきた経験から、日々の暮らしに役立つコツを紹介します。',
        profilePicture: '/images/avatars/yosuke-matsumoto.jpg'
    },
    viewCount: 1320,
    contentComponent: PostContent
};

export default post;